<template>
  <div class="payload-unknown" :class="isMe() ? 'me' : 'other'">
    <table>
      <tr v-if="isMe()">
        <td>
          <span class="time">{{
            conversation.createdAt | timeChatFormat
          }}</span>
          <span class="message">{{ conversation.message.payload }}</span>
        </td>
      </tr>
      <tr v-else>
        <td class="fix-width"><div class="logo-small"></div></td>
        <td>
          <span class="message">{{ conversation.message.payload }}</span>
          <span class="time">{{
            conversation.createdAt | timeChatFormat
          }}</span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'PayloadUnknown',
  props: {
    conversation: Object
  },
  methods: {
    isMe() {
      return this.conversation.sender === 'customer'
    }
  }
}
</script>
